module.exports = __webpack_public_path__ + "img/1557614067153182721.c22a5d35.png";